module.exports = require('./head');



//////////////////
// WEBPACK FOOTER
// ./~/lodash/first.js
// module id = 6643
// module chunks = 0